export const APP_ROUTES = {
  AUTH: {
    LOGIN: 'auth/login',
  },
  APP: {
    HOME: 'app/home',
    USERS: 'app/users',
    CLIENTS: 'app/clients',
  },
  NO_ACCESS: 'no-access',
};
